import BrowserPolicyComponent from './browser-policy.component';
import BrowserPolicyRouteConfig from './browser-policy.route';

const browserPolicyModule = angular
	.module('app.browser-policy', ['ui.bootstrap', 'ui.router', 'gettext'])
	.component('browserPolicy', BrowserPolicyComponent)
	.config(BrowserPolicyRouteConfig);

export default browserPolicyModule.name;
